var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUmbrella(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.533 2.685V1.073h-1.066v1.612C6.894 2.966.006 9.983.006 18.574c0 .565.031 1.144.094 1.722l1.062-.038a3.298 3.298 0 0 1 3.306-3.191 3.316 3.316 0 0 1 3.311 3.312h1.066a3.316 3.316 0 0 1 3.312-3.312 3.314 3.314 0 0 1 3.309 3.25v8.255c0 1.299 1.056 2.356 2.355 2.356s2.356-1.057 2.356-2.356h-1.066a1.29 1.29 0 0 1-2.579 0v-8.194h.003c0-1.826 1.485-3.312 3.311-3.312s3.312 1.486 3.312 3.312h1.066a3.316 3.316 0 0 1 3.311-3.312 3.301 3.301 0 0 1 3.304 3.162l1.063.032c.059-.565.09-1.133.09-1.687 0-8.591-6.888-15.607-15.461-15.889zM27.537 16a4.38 4.38 0 0 0-3.844 2.286C22.95 16.926 21.504 16 19.848 16s-3.101.925-3.844 2.286C15.261 16.926 13.815 16 12.159 16s-3.102.925-3.845 2.286a4.382 4.382 0 0 0-7.206-.718c.523-7.714 7.003-13.83 14.894-13.83 7.89 0 14.369 6.115 14.893 13.827A4.364 4.364 0 0 0 27.539 16z",
    fill: "#0B0C0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrella);
export default __webpack_public_path__ + "static/media/umbrella.c91c38b534887ee2cc9b6e7d91b3ce5a.svg";
export { ForwardRef as ReactComponent };